module.exports = __webpack_public_path__ + "img/logo.b844e0ae.png";